
import * as R from "ramda";
import AddressInfo from "../addressInfo";


export default function Etudiant(data) {
    let etudiant = data || {};
    this.type = "Etudiant";
    this.name = etudiant.name;
    this.address = R.isNil(data) || R.isNil(etudiant.address) ? new AddressInfo() : new AddressInfo(etudiant.address);
    this.level = etudiant.level;
    this.label = etudiant.label;
}